import './Approach.css';
import Icon from './Icon';
import useReveal from './useReveal';

// §5.05 — 8 tiles, 4×2 (2-col mobile).
const TILES = [
  { icon: 'experiential', label: 'Experiential learning' },
  { icon: 'workshop',     label: 'Interactive workshops' },
  { icon: 'role-play',    label: 'Role plays & simulations' },
  { icon: 'case-study',   label: 'Business case studies' },
  { icon: 'group',        label: 'Group activities' },
  { icon: 'coaching',     label: 'Coaching & feedback' },
  { icon: 'scenario',     label: 'Real corporate scenarios' },
  { icon: 'action',       label: 'Learning that drives action' },
];

export default function Approach() {
  const gridRef = useReveal({ stagger: 60, maxStaggered: 6 });

  return (
    <section id="approach" className="approach">
      <div className="container">
        <header className="approach__header">
          <h2 className="approach__title">Our Methodology</h2>
          <p className="approach__intro">
            Every session is practical, engaging and focused on application through experiential learning rooted in the real world.
          </p>
        </header>
        <div className="approach__grid" ref={gridRef}>
          {TILES.map((t) => (
            <div className="approach__tile" key={t.label}>
              <div className="approach__icon" aria-hidden="true">
                <Icon name={t.icon} size={26} />
              </div>
              <div className="approach__label">{t.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
